import { AlertTriangle, Clock } from 'lucide-react';
import { Modal } from './Modal';
import { Button } from './Button';

type WarningReason = 'inactivity' | 'token_expiry';

interface SessionExpiryWarningProps {
  isOpen: boolean;
  reason: WarningReason;
  onDismiss: () => void;
}

const MESSAGES: Record<WarningReason, { title: string; body: string }> = {
  inactivity: {
    title: 'Are you still there?',
    body: 'Your session will expire soon due to inactivity. Click the button below to stay signed in.',
  },
  token_expiry: {
    title: 'Session expiring soon',
    body: 'Your login session is about to expire. You will be redirected to the login page shortly.',
  },
};

export function SessionExpiryWarning({
  isOpen,
  reason,
  onDismiss,
}: SessionExpiryWarningProps) {
  const { title, body } = MESSAGES[reason];
  const Icon = reason === 'inactivity' ? Clock : AlertTriangle;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onDismiss}
      size="sm"
      showCloseButton={false}
      closeOnOverlayClick={false}
      closeOnEscape={false}
    >
      <div className="flex flex-col items-center text-center py-2">
        <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-amber-100 dark:bg-amber-900/30 mb-4">
          <Icon className="w-6 h-6 text-amber-600 dark:text-amber-400" />
        </div>
        <h3 className="text-lg font-semibold text-gray-900 dark:text-[var(--amy-text)] mb-2">
          {title}
        </h3>
        <p className="text-sm text-gray-600 dark:text-[var(--amy-muted)] mb-6">
          {body}
        </p>
        <Button onClick={onDismiss} className="w-full">
          I&apos;m still here
        </Button>
      </div>
    </Modal>
  );
}
